import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from './Components/AdminSidebar';

const HowToUse = () => {
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeLink, setActiveLink] = useState('How to Use');

  // Logout handler
  const handleLogout = () => {
    navigate('/adminlogin');
  };

  // Toggle sidebar
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Handle navigation from sidebar
  const handleNavigation = (linkName, route) => {
    setActiveLink(linkName);
    navigate(route);
  };

  // Dynamic widths
  const fullWidth = '360px';
  const collapsedWidth = '140px';

  return (
    <div className="h-screen bg-[#151419] overflow-hidden">
      <div className="flex h-full transition-all duration-300">
        {/* Sidebar */}
        <div
          className="transition-all duration-300"
          style={{ width: isSidebarCollapsed ? collapsedWidth : fullWidth }}
        >
          <AdminSidebar 
            isCollapsed={isSidebarCollapsed} 
            onToggle={toggleSidebar} 
            activeLink={activeLink}
            setActiveLink={setActiveLink}
            onLogout={handleLogout}
            onNavigate={handleNavigation}
          />
        </div>

        {/* Main Content Area */}
        <div className="flex-1 p-8 overflow-y-auto overflow-x-auto transition-all duration-300">
        
        <h1 className="text-3xl font-bold text-white mb-6">How to Use</h1>
        
        <div className="bg-[#1D1C21] border border-white/10 rounded-2xl p-6 shadow-[0_25px_80px_rgba(0,0,0,0.45)]">
          <p className="text-gray-300">How to use instructions will go here.</p>
        </div>

        </div>
      </div>
    </div>
  );
};

export default HowToUse;

